import React, { useState } from 'react'

interface FallbackImageProps {
  src?: string
  alt?: string
  style?: React.CSSProperties
  fallback: React.ReactNode
  className?: string
}

// Renders an <img> when a valid src is present; falls back to the provided
// gradient/emoji node on missing src OR onError, with no layout jump.
export function FallbackImage({ src, alt = '', style, fallback, className }: FallbackImageProps) {
  const [failed, setFailed] = useState(false)

  if (!src || failed) {
    return <div className={className} style={style}>{fallback}</div>
  }

  return (
    <div className={className} style={{ position: 'relative', overflow: 'hidden', ...style }}>
      <img
        src={src}
        alt={alt}
        onError={() => setFailed(true)}
        style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
      />
    </div>
  )
}
